<template>
	<div class="left-banner" id="leftBan">
		<div class="cloud-icon" @click.stop="toMainHomePage()">
			<div class="cloud-icon-position">
				<div class="cloud-image"></div>
				<div class="cloud-description" :style="{ fontSize: this.$i18n.locale == 'english' ? '10Px' : '12Px' }">{{$t('language.leftBanner.cloudEscription')}}</div>
			</div>
		</div>
		<!-- <div class="progressive-line"></div> -->
		<div class="navigation-menu">
			<div class="menu-title">
				<div class="menu-title-des">{{$t('language.leftBanner.commonTools')}}</div>
			</div>
			<div class="drive-option"   :key='index' :id="menuOptionSe(index)" v-for="(menuOption,index) in menuOptions"
			 @mouseover="menuHoverCurrent=index" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(index,$event)">
				<div class="drive-item" :class="[index==menuClickCurrent?'menu-select':'',index==menuHoverCurrent?driveSelect:'']">
					<div :class="[index==menuClickCurrent?'option-select':'']" v-if="index==menuClickCurrent"></div>
                    <div class="item-option">
						<div class="icon left-banner-position" :id="menuOption.icon" :class="menuOption.icon">
							<div class="list-number" v-show="false" style="display:none !important;" :id="listRedMark(index)">
								<span>{{taskListNumber}}</span>
							</div>
						</div>
						<div class="option-name">
							{{menuOption.name}}
							<div class="option-new" v-if="menuOption.isNew">{{$t('language.leftBanner.new')}}</div>
						</div>
					</div>
				</div>
			</div>
            <!-- 新手引导第二步 -->
			<div class="step-two" v-if="$store.state.beginGuideFlag&&guideStepTwo">
				<div class="bubble bubble-two-position">
					<div class="bubble-triangle"></div>
					<div class="icon-util bubble-close" style="float:right;" @click="cancelGuide()"></div>
					<div class="bubble-title">{{$t('language.leftBanner.createTask')}}</div>
					<div class="bubble-text">{{$t('language.leftBanner.createTaskText')}}</div>
					<button class="bubble-button" @click="cancelGuide()">{{$t('language.popup.reportPopup.next')}}</button>
				</div>
			</div>
		</div>
		<div class="cloud-drive-menu">
			<div class="drive-option" id="menuOption5">
				<div class="drive-item" >
					<div class="item-option home-class">
						{{$t('language.leftBanner.onlineServices')}}
					</div>
				</div>
			</div>
            <!-- 添加云盘 -->
			<div class="drive-option" id="menuOption6" @mouseover="menuHoverCurrent=10" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(10,$event)">
				<div class="drive-item" v-bind:class="[10==menuClickCurrent?menuSelect:'',10==menuHoverCurrent?driveSelect:'']">
                    <div :class="[10==menuClickCurrent?'option-select':'']" v-if="10==menuClickCurrent"></div>
					<div class="item-option">
						<div class="icon addCloudIcon left-banner-position" style="float: left;left:2Px !important;"></div>
						<div class="add-cloud-icon-name">
							{{$t('language.common.addCloud')}}
						</div>
					</div>
				</div>
                <!-- 新手引导第一步 -->
				<div class="step-one" v-if="$store.state.beginGuideFlag&&guideStepOne">
					<div class="bubble bubble-one-position">
						<div class="bubble-triangle"></div>
						<div class="icon-util bubble-close" style="float:right;" @click="cancelGuide()"></div>
						<div class="bubble-title">{{$t('language.common.addCloud')}}</div>
						<div class="bubble-text">{{$t('language.leftBanner.addCloudText')}}</div>
						<button class="bubble-button-one" :style="{marginTop:($i18n.locale == 'deutsch'||$i18n.locale == 'spanish'?'':'40Px')}"  @click="nextStepTwo()">{{$t('language.popup.reportPopup.next')}}</button>
					</div>
				</div>
			</div>
			<div class="drive-option" id="menuOption10" @mouseover="menuHoverCurrent=11" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(11,$event)">
				<div class="drive-item" v-bind:class="[11==menuClickCurrent?menuSelect:'',11==menuHoverCurrent?driveSelect:'']">
                    <div :class="[11==menuClickCurrent?'option-select':'']" v-if="11==menuClickCurrent"></div>
					<div class="item-option">
						<div class="icon addEmailIcon left-banner-position" style="float: left;left:4Px !important;top:2Px !important;"></div>
						<div class="add-cloud-icon-name">
							{{$t('language.common.addEmail')}}
							<div class="option-new" v-if="!addEmailNotNew">{{$t('language.leftBanner.new')}}</div>
						</div>
					</div>
				</div>
			</div>
			<div class="drive-option" id="menuOption8" @mouseover="menuHoverCurrent=8" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(8,$event)" v-if="hasTeam&&hasTeam.id">
				<div :class="[6==menuClickCurrent?'option-select':'']" v-if="8==menuClickCurrent"></div>
				<div class="drive-item" v-bind:class="[8==menuClickCurrent?menuSelect:'',8==menuHoverCurrent?driveSelect:'']">
					<div class="item-option">
						<div class="icon team-white-small left-banner-position" style="float: left;left:2Px !important;" ></div>
						<div class="add-cloud-icon-name">
							{{$t('language.common.team')}}
						</div>
					</div>
				</div>
			</div>
			<div class="drive-items" id="driveItems" :style="hasTeam&&hasTeam.id?'height:calc(100% - 135px);':''">
				<el-scrollbar style="height:100%;">
					<div @contextmenu.prevent="editDriveMenushow($event,index,cloud)" class="drive-option" :key='index' :id="driveOption(index)"
					 v-for="(cloud,index) in clouds" @click="addDriveSelect(index,cloud,false)" @mouseover="hoverCurrent=index,selectCloud=null"
					 @mouseout="hoverCurrent=-1">
						<div class="drive-item" v-bind:class="[index==clickCurrent?menuSelect:'',index==hoverCurrent||selectCloud==cloud?driveSelect:'']">
							<div :class="[index==clickCurrent?'option-select':'']" v-if="index==clickCurrent"></div>
                            <span class="item-option">
								<span class="icon  item-option-icon" :class="cloud.appName!='NAS'?cloud.appName+'-small':cloud.appName+'-white-small'"></span>
								<span :ref="'driveName'" class="item-option-name" :title="cloud.name">{{cloud.name}}</span>
								<div class="edit-outclass" :ref="'inputName'" @mouseover.stop="hoverCurrent=-1" @click.stop="ifClick(index)">
									<div class="edit-innerclass">
										<input class="drive-name-edit" v-model="cloud.inputValue" @focus="isflage=true" @blur="submitDriveName(cloud,index)" />
										<span class="drive-input-icon">
											<i class="icon-util name-sure" @click.stop='submitDriveName(cloud,index)'></i>
											<i class="icon-util name-cancel " @mousedown.stop='cancelEditDriveName(cloud,index)'></i>
										</span>
									</div>
								</div>
							</span>
						</div>
					</div>
				</el-scrollbar>
			</div>
			<div class="edit-drives-menus" v-show=editShow id="editDrivesMenus" v-clickoutside="editDrivesMenusClose" @mouseout="selectCloud=null">
				<div class="edit-drive-menu" @click.stop="editDriveName()">
					<div class=" rename edit-drive-position new-position"></div>
					<div style="float:left;">{{$t('language.common.rename')}}</div>
				</div>
				<div class="edit-drive-menu" @click.stop="rewriteDrive()">
					<div class="icon-util edit-small edit-drive-position"></div>
					<div style="float:left;">{{$t('language.leftBanner.edit')}}</div>
				</div>
				<div class="edit-drive-menu" @click.stop="removeDialogShow()">
					<div class=" delete edit-drive-position new-position"></div>
					<div style="float:left;">{{$t('language.leftBanner.remove')}}</div>
				</div>
				<div class="edit-drive-menu" @click.stop="propertiesDialogShow()">
					<div class=" properties edit-drive-position new-position" style="left:1Px;"></div>
					<div style="float:left;">{{$t('language.common.properties')}}</div>
				</div>
			</div>
		</div>
		<div class="progressive-line"></div>
		<div class="drive-option" id="menuOption712" style="margin-top: 5px;"
			 @mouseover="menuHoverCurrent=12" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(12,$event)">
			<div :class="[12==menuClickCurrent?'option-select':'']" v-if="12==menuClickCurrent"></div>
			<div class="drive-item" v-bind:class="[12==menuClickCurrent?'menu-select':'',12==menuHoverCurrent?driveSelect:'']">
				<div class="item-option">
					<div class="icon if_Invite_friends left-banner-position"></div>
					<div class="option-name">{{$t('language.leftBanner.inviteFriends')}}
					</div>
				</div>
			</div>
		</div>
		<div class="drive-option" id="menuOption9" style="margin-top: 5px;"
			 @mouseover="menuHoverCurrent=9" @mouseout="menuHoverCurrent=-1" @click="menuOptionSelect(9,$event)">
			<div :class="[9==menuClickCurrent?'option-select':'']" v-if="9==menuClickCurrent"></div>
			<div class="drive-item" v-bind:class="[9==menuClickCurrent?'menu-select':'',9==menuHoverCurrent?driveSelect:'']">
				<div class="item-option">
					<div class="icon ap_green_title left-banner-position"></div>
					<div class="option-name">{{$t('language.affiliateProgram.leftTitle')}}
					</div>
				</div>
			</div>
		</div>
		<propertiesDialog ref="propertiesDialog" :cloudName=cloudName :cloudId=cloudId :cloud=cloud></propertiesDialog>
		<removeDialog ref="removeDialog" :cloudId=cloudId></removeDialog>
		<editCloudDialog ref="editCloudDialog" :cloudType=cloudName :cloudId=cloudId></editCloudDialog>
		<editFtpDialog ref="editFtpDialog"></editFtpDialog>
		<editNasDialog ref="editNasDialog"></editNasDialog>
		<userStarPopup ref="userStarPopup"></userStarPopup>
      	<userStarJumpPopup ref="userStarJumpPopup"></userStarJumpPopup>
      	<userStarFeedbackPopup ref="userStarFeedbackPopup"></userStarFeedbackPopup>
		<!-- <div class="guide-popup" v-if="$store.state.beginGuideFlag"></div> -->
	</div>
</template>

<script>
	import {
		error
	} from 'util';
	import commonUtils from "@/js/workspace/common_util.js";
	import propertiesDialog from "@/components/popup/add_cloud_popups/properties_popup";
	import removeDialog from "@/components/popup/add_cloud_popups/remove_popup";
	import editCloudDialog from "@/components/popup/add_cloud_popups/edit_cloud_popup";
	import cloudExploerUtils from "@/js/workspace/cloud_exploer_util.js";
	import taskListUtils from "@/js/workspace/task_list_util.js";
	import editFtpDialog from '@/components/popup/add_cloud_popups/edit_ftp_popup';
	import editNasDialog from '@/components/popup/add_cloud_popups/edit_nas_popup';
	import commonstate from '@/js/constant.js';
	import taskOfflineUtils from '@/js/workspace/task_offline_util.js';
	import addCloudUtils from "@/js/workspace/add_cloud_utils.js";
	import userStarPopup from "@/components/popup/task_list_popups/user_star_popup";
	import userStarJumpPopup from "@/components/popup/task_list_popups/user_star_jump_popup";
	import userStarFeedbackPopup from "@/components/popup/task_list_popups/user_star_feedback_popup";
	export default {
		name: 'leftBanner',
		components: {
			propertiesDialog,
			removeDialog,
			editCloudDialog,
			editFtpDialog,
			editNasDialog,
			userStarPopup,
    		userStarJumpPopup,
    		userStarFeedbackPopup,
		},
		computed: {
			menuOptions() {
				return [{
						name: this.$t('language.leftBanner.taskList'),
						icon: 'taskList'
					}, {
						name: this.$t('language.leftBanner.cloudTransfer'),
						icon: 'cloudTransfer'
					},{
						name:this.$t('language.teamTransfer.teamTransfer'),
						icon: 'teamTransfer'
					}, {
						name: this.$t('language.leftBanner.cloudSync'),
						icon: 'cloudsync'
					}, 
                     {
                        name:this.$t('language.cloudBackup.cloudBackup'),
                        icon:'cloudbackup'
                    },
                    {
						name: this.$t('language.common.btLink'),
						icon: 'linkTask'
					},
					{
						name: this.$t('language.leftBanner.shares'),
						icon: 'shares'
					},
					{
						name: this.$t('language.leftBanner.emailTransfer'),
						icon: 'emailTransfer',
						isNew: !commonUtils.getActiveTagByStore("emailTransferNotNew"),
					},

				]; //左侧菜单栏
			},
			addEmailNotNew: {
				get(){
					return commonUtils.getActiveTagByStore("addEmailNotNew");
				},
				set(){}
			}
		},
		data() {
			return {
				clickCurrent: -1,
				menuClickCurrent: -1,
				hoverCurrent: -1,
				menuHoverCurrent: -1,
				indexCurrent: 0,
				cloudIndex: -1,
				cloudName: null,
				cloudId: null,
				cloud: '',
				clouds: [],
				menuSelect: 'menu-select',
				driveSelect: 'drive-select',
				editShow: false,
				editcloudName: '',
				isflage: true, //用于控制是否聚焦
				guideStepOne: true,
				guideStepTwo: false,
				selectCloud: null,
				selectItem: null,
				editCloud: null,
                taskListNumber: 0,
				nowCloudName:null,
				hasTeam:null,
                user:commonUtils.getUser(),
			}
		},
		inject: ["reload"],
		watch: {
			'$store.getters.getUsersDrives': function(newValue, oldValue) {
				let that = this;
				if (this.$store.getters.getUsersDrives.length) {
                    if(!oldValue.length){
                    this.clouds = Object.assign([], newValue);
                   }else{//如果含有数据，只是更新了数据
                    $.each(this.clouds,function(i,item){
                        $.each(newValue,function(j,jItem){
                            if(item.id==jItem.id){
                                if(item.inputValue){
                                if(item.name!=jItem.name){
                                    jItem.indexCurrent=item.indexCurrent;
                                    jItem.name=item.name;
                                }
                                jItem.inputValue=item.inputValue;
                                }
                            }
                        })
                    });
                   this.clouds= Object.assign([],newValue);
                    }
				}
                //如果没有添加云盘则跳到add_cloud界面,暂时无需此功能
                // if(!this.clouds.length){
                //     this.menuOptionSelect(6);
                // }
			},
			'$store.state.teamCloud':{ //监听的对象
				deep:true, //深度监听设置为 true
				handler:function(newV,oldV){
					this.hasTeam = newV;
				}
			},
		},
		mounted() {
			this.getMenuOption();
			//禁用拖拽功能
			commonUtils.dragDisAble('leftBan', this);
		},
		created(){
			//查询是否是子账号
			this.hasPermission();
		},
		methods: {
            //判断游客登录新手引导是否显示
            judgeGuideSHow(){
            let user=commonUtils.getUser();
            let newSign = localStorage.getItem("noviceGuide"+user.id);
			//获取当前浏览器类型
			let type = commonUtils.judgeClient();
			if(type == 'Android'||type == 'IOS'){
				//手机端需要在新手指引前打开，暂不开放
				// this.$parent.$refs.rightContBan.appRecommendShow();
			}
			if (!user.loginTime&&!newSign) {
				this.$store.state.beginGuideFlag = true;
                this.guideStepOne = true;
                localStorage.setItem("noviceGuide"+user.id,true);
			}else{
				this.$parent.$refs.rightContBan.appRecommendShow();
			}
            },
			ifClick(index) {
				this.hoverCurrent = -1;
				if (this.clickCurrent == index) {
					this.clickCurrent = -1;
				}
			}, //跳转到主页面
			toMainHomePage() {
                let language = commonUtils.getLocaleToIndex(localStorage.getItem("locale"));
                if(language!='en'){
                 window.open(commonstate.frontEndUrl+'/'+language+ "/");
                }else{
                 window.open(commonstate.frontEndUrl + "/");    
                }
			}, //选中左侧导航栏
			getOption(tokenId) {
				let that = this;
				let allClouds = this.clouds;
				for (let i = 0; i < allClouds.length; i++) {
					if (allClouds[i].id == tokenId) {
						that.clickCurrent = i;
						break;
					}
				}
			},
			//用于刷新或初始化界面/或者添加云盘时候选中左侧菜单
			getLeftOption(tokenId) {
				let that = this;
				let itemIndex;
				let item;
				let allClouds = this.clouds;
				for (let i = 0; i < allClouds.length; i++) {
					if (allClouds[i].id == tokenId) {
						item = allClouds[i];
						itemIndex = i;
						that.clickCurrent = i;
						break;
					}
				}
				//用于添加云盘时候的跳转路径
				if (item&&that.$route.query.folderId == item.rootId) {
					let pathJson = [{
						id: item.rootId,
						name: item.name,
						driveId: item.id
					}]
					let JsonList = Object.assign([], pathJson);
					this.$store.commit("setPathJson", {
						folderId: item.rootId + item.id,
						json: JsonList
					});
				}
				if (item) {
					let path = 'cloudExploer';
					//邮件跳转邮件页面
					if(commonstate.emailClouds.includes(item.appName)){
						path = 'emailExploer';
					}
					this.$router.push({
						name: path,
						query: {
							cloudType: item.driveType,
							folderId: that.$route.query.folderId,
							folderName: that.$route.query.folderName,
							tokenId: that.$route.query.tokenId,
							docType: that.$route.query.docType,
							queryParameter: that.$route.query.queryParameter,
						}
					});
				}
			}, //如果刷新界面后，先判断之前缓存中是否有选中的项
			getMenuOption() {
                 let leftclick = parseInt(Base64.decode(localStorage.getItem("leftbannerClick"+this.user.id)));
                 let menuclick = parseInt(Base64.decode(localStorage.getItem("leftbannerMenuClick"+this.user.id)));
				//为team时，有tokenId也要选中
				if ((menuclick != -1 && !this.$route.query.tokenId) || menuclick==8) {
					this.clickCurrent = -1;
					this.menuClickCurrent = menuclick;
					this.menuSelectNotJump(this.menuClickCurrent);
				}
				if (leftclick != -1 && !this.$route.query.tokenId) {
					this.menuClickCurrent = -1;
					this.clickCurrent = leftclick;
					this.driveOptionSelect(this.clickCurrent);
				}
                if(leftclick!=-1 && this.menuClickCurrent==-1 && this.clickCurrent==-1 && this.$route.query.tokenId){
                    this.clickCurrent=leftclick;
                }
			},
			onDrag: function(e) {
				e.stopPropagation();
				e.preventDefault();
			},
			cancelGuide() { //取消新手指引
				this.$store.state.beginGuideFlag = false;
                let that = this;
                var user = this.user; 
                 //如果用户是新用户，自动弹出弹窗
                 //如果用户是新用户，自动弹出弹窗
				 //自动打开通知弹窗
                // commonUtils.getNotifications(that.$parent.$refs.rightContBan);
				//暂不开放
                // that.$parent.$refs.rightContBan.appRecommendShow();        
				
                //  if(!localStorage.getItem('timeSale'+user.id)){
                 // localStorage.setItem('timeSale'+this.user.id,'show');
                //新春活动只针对繁体
            //    if(localStorage.getItem("locale")!="traditionalChinese"){
            //       that.$parent.$refs.rightContBan.showFunnel();
            //     }else{
                    // var timerExpired = commonUtils.getTimerExpired(commonstate.activityEndedTimer);
                    // if(timerExpired){
                     that.$parent.$refs.rightContBan.showFunnel();
                    // }
                // }
              // that.$parent.$refs.rightContBan.letNotificationsShow=true;
              // that.$parent.$refs.halloweenSaleDialog.notifyShow=true;
               return;
            //    }    
                
			},
			nextStepTwo() { //新手指引第二步
				this.guideStepOne = false;
				this.guideStepTwo = true;
			},
			editDriveName() { //编辑云盘名称
				this.hoverCurrent = -1;
				if (this.cloudIndex == this.clickCurrent) {
					this.clickCurrent = -1;
				}
				this.editInputStyle("block", "none", this.editCloud);
				this.hoverCurrent = -1;
				this.editShow = false;
			}, //取消编辑云盘效果
			cancelEditDriveName(cloud, index) {
				let that = this;
				that.isflage = false;
				setTimeout(function() {
					that.editInputStyle("none", "", cloud);
					cloud.inputValue = cloud.oldDriveName;
					if (that.menuClickCurrent == -1 && that.clickCurrent == -1) {
						that.clickCurrent = index;
					}
				}, 200);

			}, //提交云盘名
			submitDriveName(cloud, index) {
				let that = this;
				if (this.isflage) {
					if (cloud.inputValue.length > 200) {
						this.$toast({
							text: that.$t('language.home.cloudDiskName'),
							type: 'fail',
							idValue: "leftBan"
						});
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					if (commonstate.patternDriveName.test(cloud.inputValue)) {
						that.$toast({
							text: that.$t('language.home.driveNameNotContain'),
							type: 'fail',
							idValue: "leftBan",
						});
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					if (cloud.inputValue == cloud.oldDriveName) {
						this.cancelEditDriveName(cloud, index);
						return false;
					}
					let renameData = new addCloudUtils.renameDrive(commonUtils.getUser().id, cloud.id, cloud.inputValue);
                    this.isflage = false;
                    if(!cloud.haveLoad){//如果还未来得及取得返回数据
                     cloud.name=cloud.inputValue;
                     that.editInputStyle("none", "", cloud);//还原编辑样式
                   }
					this.Utils.doDrivesRequest("rename", renameData).then(res => {
						if (res.status == '200') {
							this.isflage = true;
							that.editInputStyle("none", "", cloud);
							let driveName = 'driveName' + cloud.indexCurrent;
							let divDom = that.$refs.driveName[cloud.indexCurrent];
							cloud.name =res.drive.name;
							this.$store.commit("setUsersDrives", this.clouds);
							if (that.$parent.$refs.routView.clouds) {
								that.$parent.$refs.routView.clouds = that.clouds;
							}
							if (that.$parent.$refs.routView.pathJson) { //修改用户在当前目录路径
								let pathJson = that.$parent.$refs.routView.pathJson;
								$.each(pathJson, function(i, item) { //修改用户在当前目录路径
									if (item.driveId == cloud.id && item.name == cloud.oldDriveName) {
										item.name = cloud.name;
										that.$store.commit("setPathJson", {
											folderId: pathJson[pathJson.length - 1].id + cloud.id,
											json: pathJson
										});
										that.updateAllPathJson(cloud); //更改该节点的所有目录节点
										return false;
									}
								});
							}
							that.$nextTick(function() {
								if (that.menuClickCurrent == -1 && that.clickCurrent == -1) {
									$.each(that.clouds, function(m, tCloud) {
										if (tCloud.id == cloud.id) {
											that.clickCurrent = m;
											return false;
										}
									});
								}
							});
						} else {
							that.$toast({
								text: this.$t('language.exception.' + res.reason),
								type: 'fail',
								idValue: "leftBan"
							});
						}
					});
				}
			}, //修改云盘所有的路径
			updateAllPathJson(cloud) {
				let that = this;
				let allPathJson = this.$store.state.pathJson;
				$.each(allPathJson, function(index, jsonItem) {
					let pathJson = jsonItem.json;
					$.each(pathJson, function(i, item) {
						if (item.driveId == cloud.id && item.name == cloud.oldDriveName) {
							item.name = cloud.name;
							that.$store.commit("setPathJson", {
								folderId: pathJson[pathJson.length - 1].id + cloud.id,
								json: pathJson
							});
							return false;
						}
					});
				});
			}, 
            //更改重命名时的样式
			editInputStyle(inputDomStye, divDomStyle, cloud) {
                if(!cloud.indexCurrent){
                    cloud.indexCurrent = this.cloudIndex;
                }
				let inputName = 'inputName' + cloud.indexCurrent;
				let driveName = 'driveName' + cloud.indexCurrent;
				let inputDom = this.$refs.inputName[cloud.indexCurrent];
				let divDom = this.$refs.driveName[cloud.indexCurrent];
                if(inputDom){
				inputDom.style.display = inputDomStye;
                inputDom.children[0].children[0].select();
                }
                if(divDom){
				divDom.style.display = divDomStyle;
                }
			},
             //显示云盘右键菜单
			editDriveMenushow(event, index, cloud) {
				this.selectItem = cloud;
				this.selectCloud = cloud;
				this.hoverCurrent = index;
				cloud.indexCurrent = index;
				this.editCloud = cloud;
				this.cloudIndex = index;
				if (this.$parent.$refs.routView.clouds) {
					this.$parent.$refs.routView.editHomeShow = false;
				}
				let element = event.currentTarget;
                cloud.inputValue = cloud.name;
				cloud.oldDriveName = cloud.name;
				this.$nextTick(function() {
					commonUtils.multipleMenuShow("editDrivesMenus", event);
				});
				this.editShow = true;
			},
			editDrivesMenusClose() {
				this.editShow = false;
			},
			driveOption(i) {
				return "driveOption" + i;
			},
			menuOptionSe(i) {
				return "menuOption" + i;
			},
			listRedMark(i) {
				return "listRedMark" + i;
			}, 
            menuSelectNotJump(index){
                this.clickCurrent = -1;
				this.hoverCurrent = -1;
				this.menuClickCurrent = index;
                //防止用户想跳支付页面却跑去其他页面
                if(this.$route.name!='paySys'){
				this.handleSelect(index);
                }
				this.$store.commit('setleftbannerClick', this.clickCurrent);
				this.$store.commit('setleftbannerMenuClick', this.menuClickCurrent);
            },
            //选中上面的菜单
			menuOptionSelect(index) {
				this.clickCurrent = -1;
				this.hoverCurrent = -1;
				this.menuClickCurrent = index;
				this.handleSelect(index);
				this.$store.commit('setleftbannerClick', this.clickCurrent);
				this.$store.commit('setleftbannerMenuClick', this.menuClickCurrent);
			}, //选中云盘列表
			driveOptionSelect(index) {
				this.menuClickCurrent = -1;
				this.menuHoverCurrent = -1;
				this.clickCurrent = index;
				this.$store.commit('setleftbannerClick', this.clickCurrent);
				this.$store.commit('setleftbannerMenuClick', this.menuClickCurrent);
				this.$store.commit("setCatalogFileId", '');
			}, 
			addDriveSelect(index, cloud, flag) {
				this.driveOptionSelect(index);
				if (!cloud.rootId) {
					cloud.rootId = "";
				}
				this.$store.commit('setListData', {
					id: cloud.rootId,
					ud: commonUtils.getUser().id,
					dd: cloud.id,
					cloud: cloud
				});
				let pathJson = [{
					id: cloud.rootId,
					name: cloud.name,
					driveId: cloud.id
				}]
				let pathJsonData = this.$store.getters.getPathJson;
				let pathData = pathJson[cloud.rootId + cloud.id];
				let JsonList = Object.assign([], pathJson);
				if (!pathData || (pathData.json[0].driveId != cloud.id)) {
					this.$store.commit("setPathJson", {
						folderId: cloud.rootId + cloud.id,
						json: JsonList
					});
				}
				this.$store.commit('setCloudExploerPasteItems', cloud);
				let path = 'cloudExploer';
				//邮件跳转邮件页面
				if(commonstate.emailClouds.includes(cloud.appName)){
					path = 'emailExploer';
				}
				this.$router.push({
					name: path,
					query: {
						cloudType: cloud.driveType,
						folderId: cloud.rootId,
						folderName: cloud.name,
						tokenId: cloud.id
					}
				});
			}, //点击选项，跳转路径
			handleSelect(index) {
				// 用户好评弹窗（从任务列表切到其它导航）
				if (index!=0 && this.$store.state.isShowUserStarReady) {
					// 下次不显示
					this.$store.state.isShowUserStarReady = false;
					this.$store.state.isShowUserStar = false;
					// 显示弹窗
					this.$refs.userStarPopup.isShowStarPopup = true;
					taskListUtils.userStarUpdateRequest({createReason:1,score:0,trustpilot:false,content:''});
				}
				// this.$parent.$refs.rightContBan.resetEmail = false;
				switch (index) {
					case 0:
						let taskRedMark = document.getElementById("listRedMark0");
						taskRedMark.style.display = 'none';
						if(this.taskListNumber){
						this.$store.state.taskListAddNewNumber=this.taskListNumber;
						}
						this.taskListNumber = 0;
						this.$router.push('/mc_project/task_list');
						break;
					case 1:
						this.$router.push('/mc_project/cloud_transfer');
						break;
                    case 2:
						this.$router.push('/mc_project/team_transfer');
						break;
					case 3:
						this.$router.push('/mc_project/cloud_sync');
						break;
                    case 4:
                        this.$router.push('/mc_project/cloud_backup');
						break;
					case 5:
						let taskRedMark3 = document.getElementById("listRedMark5");
						taskRedMark3.style.display = 'none';
						this.taskListNumber = 0;
						// this.$store.state.arr=[];
						this.$store.state.syncArr = [];
						this.$router.push('/mc_project/remote_task');
						break;
					case 6:
						this.$router.push('/mc_project/shares');
						break;
					case 7:
						if(!commonUtils.getActiveTagByStore("emailTransferNotNew")){
							this.menuOptions[index].isNew = false;
							commonUtils.saveActiveTagByUser(this,"emailTransferNotNew",true);
						}
						this.$router.push('/mc_project/email_transfer');
						break;
					case 10:
						this.$router.push({
							name: 'addCloud'
						});
						break;
					case 11:
						if(!commonUtils.getActiveTagByStore("addEmailNotNew")){
							this.addEmailNotNew = true;
							commonUtils.saveActiveTagByUser(this,"addEmailNotNew",true);
						}
						this.$router.push({
							name: 'addEmail'
						});
						break;
					case 12:
						this.$router.push('/mc_project/inviteFriends');
						break;
					case 8:
						let teamCloud = this.hasTeam;
						if(teamCloud&&teamCloud.id){
							this.$store.commit('setListData', {
								id: teamCloud.rootId,
								ud: commonUtils.getUser().id,
								dd: teamCloud.id,
								cloud: teamCloud
							});
								let pathJson = [{
									id: "/",
									name: this.$t('language.common.team'),
									driveId: teamCloud.id
								}]
								let JsonList = Object.assign([], pathJson);
								this.$store.commit("setPathJson", {
									folderId: "/" + teamCloud.id,
									json: JsonList
								});
								this.$router.push({
									name:'subAccountTeam',
									query: {
										cloudType: "team",
										folderId: "/",
										folderName: this.$t('language.common.team'),
										tokenId: teamCloud.id,
										cloudId: teamCloud.id,
										name: "root",//确定显示team根目录
									}
								});
							}
						break;
					case 9:
						this.$router.push('/mc_project/affiliateProgram');
						break;
				}
			},
			//显示详情
			propertiesDialogShow() {
                let that = this;
				this.editShow = false;
                let getData=new addCloudUtils.getData(commonUtils.getUser().id,this.selectItem.id);
                that.Utils.doDrivesRequest("get", getData).then(res => {
                     if (res.status == 200) {
                           this.selectItem.driveInfo = res.drive;
                           //this.selectItem.driveInfo = res.drive.usedSpace;
                        //    if(res.drive.username){
                        //        this.selectItem.driveInfo.username=res.drive.username;
                        //    }
                        //     if(res.drive.email){
                        //        this.selectItem.driveInfo.username=res.drive.email;
                        //    }
                           addCloudUtils.openProperties(that,res.drive.totalSpace,res.drive.usedSpace);
                     }
                });
			}, //显示删除云盘菜单
			removeDialogShow() {
				let that = this;
				this.editShow = false;
				this.cloudId = this.clouds[this.cloudIndex].id;
				let allTasklistData = that.$store.state.taskListArr;
				$.each(allTasklistData, function(index, data) {
					if (!data.sources) {
						if ((data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId)) {
							that.$refs.removeDialog.removeShow = true;
							return false;
						}
					} else if (data.sources) {
						$.each(data.sources, function(m, item) {
							if ((data.fromItem.driveId == that.cloudId || data.toItem.driveId == that.cloudId || item.fromItem.driveId ==
								that.cloudId || item.toItem.driveId == that.cloudId)) {
								that.$refs.removeDialog.removeShow = true;
								return false;
							}
						});
					}
					if (index == allTasklistData.length - 1 && !that.$refs.removeDialog.removeShow) {
						addCloudUtils.deletePage(that.cloudId, that);
					}
				});
				if (!allTasklistData.length) {
					addCloudUtils.deletePage(that.cloudId, that);
				}
			},
			//编辑云盘
			rewriteDrive() {
				this.$refs.editCloudDialog.cloudName = this.clouds[this.cloudIndex].appName;
				this.$refs.editCloudDialog.cloudInfo = this.clouds[this.cloudIndex];
				this.$refs.editCloudDialog.cloudIcon = this.clouds[this.cloudIndex].appName;
				this.editShow = false;
				if (this.clouds[this.cloudIndex].appName == 'FTP') {
					this.$refs.editFtpDialog.ftpDialog = true;
					this.$refs.editFtpDialog.cloudInfo = this.clouds[this.cloudIndex];
					let ftpInfo = this.clouds[this.cloudIndex].driveInfo;
					addCloudUtils.openFtpInfo(ftpInfo, this);
				} else if (this.clouds[this.cloudIndex].appName == 'NAS') {
					let nasInfo = this.clouds[this.cloudIndex].driveInfo;
					addCloudUtils.openNasInfo(nasInfo, this);
				} else {
					if(this.clouds[this.cloudIndex].appName == 'iCloudPhotos' || this.clouds[this.cloudIndex].appName == 'iCloudDrive'){
						this.$refs.editCloudDialog.appleId = '';
						this.$refs.editCloudDialog.password = '';
					}
					this.$refs.editCloudDialog.editCloudShow = true;
					this.$refs.editCloudDialog.inputCloudNameValue = this.clouds[this.cloudIndex].name;
					this.$refs.editCloudDialog.email = this.clouds[this.cloudIndex].driveInfo.email;
					this.cloudName = this.clouds[this.cloudIndex].appName;
					this.cloudId = this.clouds[this.cloudIndex].id;
					this.$refs.editCloudDialog.tipShow = false;
					this.$nextTick(function() {
						addCloudUtils.getContainerHeight(this.$refs.editCloudDialog);
					});
				}
			}, 
			//删除云盘成功
			deleCloudSuccess() {
				return new Promise((resolve, reject) => {
					let that = this;
					let deleteCloud = this.clouds[this.cloudIndex];
					this.clouds.splice(this.cloudIndex, 1);
					if (this.cloudIndex < this.clickCurrent) {
						that.clickCurrent = that.clickCurrent - 1;
					}
					let allCloud = Object.assign([], this.clouds);
					$.each(allCloud, function(m, mCloud) {
						if (mCloud.children) {
							delete mCloud.children;
						}
					});
					this.$store.commit("setUsersDrives", allCloud);
					taskListUtils.delteHavaTask(that.cloudId);
					this.betchDeleteOfflineTask(commonUtils.getUser().id, that.cloudId);
					if (this.$parent.$refs.routView.clouds) {
						this.$parent.$refs.routView.clouds = this.clouds;
					}
					if (this.clouds.length == 0) {
						this.menuOptionSelect(10);
					}
					if (this.$route.name == 'cloudExploer' && deleteCloud.id == this.$route.query.tokenId) {
						this.menuOptionSelect(10);
					}
					if (this.$route.name == 'emailExploer' && deleteCloud.id == this.$route.query.tokenId) {
						this.menuOptionSelect(11);
					}
					resolve(true); // 删除成功，将布尔值传递给调用方
				})
			},
			 //跳转到老版本
			switchOldVersion() {
				// let language = commonUtils.getLocaleTo(localStorage.getItem("locale"));
				// var tmp = new Date().getTime();
				//window.location.href = commonstate.oldVersionUrl + "/index.jsp?rl=" + language + "&tmp=" + tmp + "#home";
				var user = commonUtils.getUser();
				window.location.href = commonstate.oldVersionUrl + "/action/userinfo!switchOld?ud="+user.id+"&salt="+user.salt;
			}, // 批量删除离线任务
			betchDeleteOfflineTask(ud, dd) {
				let that = this;
				let urlDeleteData = taskOfflineUtils.deleteUrl(ud, dd);
				this.Utils.doTasksRequest("cancel", urlDeleteData).then(res => {
					that.updateOfflineStore(dd);
				});
				let torrentDeleteData = taskOfflineUtils.deleteTorrent(ud, dd);
				this.Utils.doTorrentRequest("deleteBetch", torrentDeleteData).then(res => {
					that.updateOfflineStore(dd);
				});
			}, // 更新离线任务缓存
			updateOfflineStore(dd) {
				const vm = window.vm.$children[0].$refs.routerView.$refs.routView;
				if(vm.offlineTaskData){
					vm.refresh()
				}else{
					let offlineTaskData = this.$store.state.remoteTaskArr;
					let offlineList = [];
					if (offlineTaskData) {
						offlineTaskData.forEach(task => {
							let driveId = task.toItem.driveId;
							if (driveId != dd) {
								offlineList.push(task)
							}
						});
						this.$store.commit("setRemoteTaskArr", offlineList);
					}
				}
			},
			//查询是否有别人给予的权限（是否是别人的子账号）
			hasPermission(){
				// console.log(this.$store.getters.getTeamCloud)
				// let that = this;
				// this.hasTeam = this.$store.getters.getTeamCloud;
				// this.Utils.doDrivesRequest("has_limits", {ud:commonUtils.getUser().id}).then(res => {
				// 	if(res.status=="200" && res.teamCloud){
				// 		that.$store.commit("setTeamCloud", res.teamCloud);
				// 		that.hasTeam = res.teamCloud;
				// 	}else{
				// 		that.$store.commit("setTeamCloud", {});
				// 		that.hasTeam = {};
				// 	}
				// })
			}
		},
	}
</script>

<style>
    #menuOption5{
        cursor: auto !important;
    }
	.list-number {
		width: 13Px;
		height: 13Px;
		background-color: red;
		border-radius: 50%;
		position: relative;
		left: 11Px;
		top: -6Px;
		font-size: 8Px;
	}

	.list-number span {
		text-align: center;
		display: block;
		color: #fff;
		font-weight: bold;
		position: absolute;
		top: -10Px;
		bottom: 0;
		left: 0;
		margin: 0;
		right: 0;
	}

	.home-class {
		font-weight: bold;
		font-size: 16px;
		/*no*/
		color: #fff;
	}

	/* .guide-popup {
		flex-direction: column;
		align-items: center;
		position: absolute;
		overflow: hidden;
		display: flex;
		height: 100%;
		width: 100%;
		bottom: 0;
		right: 0;
		left: 0;
		top: 0;
		z-index: 200;
        background-color: rgba(0, 0, 0, 0.3);
	} */

	.step-one {
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 35px;/*no*/
        width: 220px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 201;
        top:380px;/*no*/
        left: 15px;/*no*/
        box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
	}

	.step-two {
		box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		flex-direction: column;
		align-items: center;
		display: flex;
	    height: 140px;/*no*/
        width: 220px;/*no*/
        display: block;
        float: left;
        position: absolute;
        z-index: 250;
        top: 135px;/*no*/
        left: 15px;/*no*/
	}

	.step-three {
		box-shadow: 0 0 0 8888Px rgba(0, 0, 0, 0.5);
		flex-direction: column;
		align-items: center;
		display: flex;
		height: 100%;
		/*no*/
		width: 220px;
		/*no*/
		display: block;
		float: left;
		position: absolute;
		z-index: 201;
		left: 0;
        bottom: 0;
        right: 0;
        top: 0;
        margin: 0 auto;
	}

	.edit-innerclass {
		width: 165px;
		/*no*/
		height: 35px;
		/*no*/
		margin-left: 5px;
		/*no*/
		float: left;
		position: relative;
	}

	.bubble {
		width: 500px;
		/*no*/
		height: 230px;
		/*no*/
		background-color: #FFF;
		position: relative;
		z-index: 201;
		padding: 20px;
		/*no*/
		box-sizing: border-box;
	}

	.bubble-one-position {
		left: 260px;
		/*no*/
		top: -90px;
		/*no*/
	}

	.bubble-two-position {
		left: 260px;
		/*no*/
		top: -65px;
		/*no*/
	}

	.bubble-three-position {
		left: 250px;
		/*no*/
		top: -192px;
		/*no*/
	}

	.edit-outclass {
		display: none;
		width: 235px;
		/*no*/
		height: 40px;
		/*no*/
	}

	.bubble-title {
		font-size: 24px;
		/*no*/
		color: #5065bc;
		font-weight: bold;
		margin-top: 35px;
		/*no*/
	}

	.bubble-text {
		font-size: 16px;
		/*no*/
		color: #6f7886;
		margin-top: 15px;
		/*no*/
	}

	.bubble-button {
		float: right;
		margin-top: 60px;
		/*no*/
	}

	.bubble-button-one {
		float: right;
	}

	.bubble-triangle::after {
		content: '';
		width: 0;
		height: 0;
		border: 20px solid;
		/*no*/
		position: absolute;
		bottom: 95px;
		/*no*/
		right: 500px;
		/*no*/
		border-color: #fff transparent transparent;
		transform: rotate(90deg);
	}

    .bubble-triangleThree::after {
   	content: '';
    width: 0;
    height: 0;
    border: 20px solid;/*no*/
    position: absolute;
    bottom: 0px;/*no*/
    right: 500px;/*no*/
    border-color: #fff transparent transparent;
    -webkit-transform: rotate(90deg);
    transform: rotate(90deg);
    }

	.drive-input-icon {
		position: absolute;
		top: 7px;
		/*no*/
		right: -3px;
		/*no*/
	}

	.drive-name-edit {
		background: #fff !important;
		margin-top: 7px;
		/*no*/
		height: 25px;
		/*no*/
		width: 150px;
		/*no*/
		float: left;
		margin-left: 10%;
		font-size: 14px;
		/*no*/
		padding: 0px 40px 0px 0px;
		/*no*/
		border: none !important;
		float: left;
		box-sizing: border-box;
	}

	.left-banner {
		width: 250px;
		/*no*/
		height: 100%;
		background-color: #3E4678;
		float: left;
		box-sizing: border-box;
		background-size: cover;
		min-height: 510px;
		/*no*/
	}

	.cloud-icon {
		width: 100%;
		height: 65px;
		/*no*/
		box-sizing: border-box;
		display: flex;
		align-items: center;
		vertical-align: middle;
		line-height: 50%;
		cursor: pointer;
	}

	.cloud-icon-position {
		width: 100%;
		height: 100%;
	}

	.cloud-image {
		width: 173px;
		/*no*/
		height: 39px;
		/*no*/
		background-image: url("../../assets/images/logo.png");
		position: relative;
		top: 10px;
		/*no*/
		float: left;
	}

	.cloud-description {
		font-size: 12px;/*no*/
		color: #FFF;
		position: relative;
		left: 70Px;
		margin: 0;
		top: -1Px;
		float: left;
		width: 170Px;
		line-height: 13Px;
	}


	.switchOld {
		width: 22px;
		/*no*/
		height: 20px;
		/*no*/
		background-position: -860px -55px;
		/*no*/
	}

	.progressive-line {
		width: 100%;
		height: 1px;
		/*no*/
		background: -webkit-linear-gradient(left, rgba(255, 255, 255, 0), #4A5590, rgba(255, 255, 255, 0));
		background: linear-gradient(to right, rgba(255, 255, 255, 0), #4A5590, rgba(255, 255, 255, 0));
	}

	.navigation-menu {
		width: 100%;
		height: 315Px;
		/*no*/
	}

	.menu-title {
		width: 100%;
		height: 35px;
		/*no*/
		color: #FFF;
		padding: 0 0 0 9%;
		box-sizing: border-box;
		position: relative;
	}

	.menu-title-des {
		margin: auto;
		height: 16px;
		/*no*/
		position: absolute;
		top: 0;
		bottom: 0;
		font-weight: bold;
	}

	.left-banner-position {
		position: absolute;
		margin: auto;
		top: -2px;
		/*no*/
		bottom: 0;
		left: 0;
	}

	.option-name {
		float: left;
		position: relative;
		cursor: pointer;
		font-size: 14px;
		/*no*/
		left: 40px;
		/*no*/
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.option-new{
		background: linear-gradient(270deg, #FF7913 0%, #FF4646 100%);
		border-radius: 8px 8px 8px 0px;/*no*/
		height: 12px;/*no*/
		font-size: 11px;/*no*/
		font-family: ArialMT;
		line-height: 11px;/*no*/
		color: #FFFFFF;
		float: right;
		padding: 2px 6px;/*no*/
		margin: 9px 10px;/*no*/
	}

	.add-cloud-icon-name {
		float: left;
		position: relative;
		cursor: pointer !important;
		font-size: 14px;
		/*no*/
		left: 42px;
		/*no*/
	}

	.drive-title {
		width: 100%;
		height: 35px;
		/*no*/
		color: #FFF;
		padding-left: 9%;
		box-sizing: border-box;
		line-height: 40px;
		/*no*/
		cursor: pointer;
	}

	.drive-title-Des {
		width: 100%;
		margin: auto;
		height: 100%;
		font-weight: bold;
	}

	.menu-option {
		width: 100%;
		height: 35px;
		/*no*/
		line-height: 30px;
		/*no*/
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		box-sizing: border-box;
		padding: 6.4% 0 0 9%;
	}

	.add-cloud-option {
		width: 100%;
		height: 30px;
		/*no*/
		line-height: 30px;
		/*no*/
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		cursor: pointer;
		padding-left: 9%;
		box-sizing: border-box;
		padding-top: 2%;
		margin-top: 4.4%;
	}

	.cloud-drive-menu {
		width: 100%;
		height: calc(100% - 465px);
		/*no*/
	}

	.drive-items {
		width: 100%;
		height: calc(100% - 110px);
		/*no*/
		/* overflow-x: hidden;
       overflow-y: auto; */
      
	}

	.drive-items::-webkit-scrollbar {
		width: 5px;
		/*no*/
		/*宽度*/
		border-radius: 5px;
		/*no*/
		background-color: #35363a;
		/*背景颜色*/
	}

	.drive-items::-webkit-scrollbar-thumb {
		height: 1px;
		/*no*/
		border-radius: 5px;
		/*no*/
		background-color: #becae4;
	}

	.menu-select {
		color: #F3F4F6 ! important;
		background-image: linear-gradient(to right, #646A92, #3E4678);
		height: 100%;
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		cursor: pointer;
		box-sizing: border-box;
	}

	.drive-select {
		color: #F3F4F6;
		background-image: linear-gradient(to right, #646A92, #3E4678);
		height: 100%;
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		cursor: pointer;
	}

	.drive-option {
		width: calc(100% - 2px);
		/*no*/
		height: 35px;
		/*no*/
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		cursor: pointer;
		overflow: hidden;
		line-height: 35px;
		/*no*/
        
	}
    .drive-option-add{
        position: relative;
    }
	.item-option {
		/* width: calc(100% - 40Px); */
		width: calc(100% - 29Px);
		position: relative;
		left: 9%;
		float: left;
		height: 100%;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.item-space {
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
		font-size: 12px;
		/*no*/
	}

	.drive-item {
		min-width: 75%;
		height: 100%; 
        position: relative;
	} 

	.menu-item {
		width: 100%;
		height: 100%;
	}

	.left-buttom {
		width: 100%;
		height: 4%;
		display: table;
	}

	/*左侧底部导航栏*/
	.buttom-option {
		width: 100%;
		height: 20Px;
		font-size: 14px;
		/*no*/
		color: #A2ABE1;
		cursor: pointer;
		padding-left: 9%;
		box-sizing: border-box;
		display: table-cell;
		vertical-align: middle;
        position: relative;
	}

	.buttom-option-name {
    left: 60Px;
    cursor: pointer;
    height: 14Px;
    position: absolute;
    top: 0;
    right: 0;
    margin: auto;
    bottom: 0;
	}

	.item-option-name {
		width: calc(100% - 40Px);
		float: left;
		margin-left: 10%;
		font-size: 14px;
		/*no*/
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: absolute;
	}

	.item-option-icon {
		float: left;
		position: relative;
		top: 20%;
		left: 1%;
	}

	.edit-drive-menu:hover {
		background-color: #ebf3fe;
		cursor: pointer;
	}

	.edit-drive-position {
		float: left;
		margin: 7px 10px 0 0;
		/*no*/
	}

	.option-select {
		width: 2px;
		/*no*/
		height: 35px;
		/*no*/
		background: #fff;
		position: absolute;
		left: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/left_banner.vue